import { css } from 'styled-components';

export interface BadgeOrigin {
  vertical: 'bottom' | 'top';
  horizontal: 'left' | 'right';
}

const anchorOriginTopRight = css`
  top: 0;
  right: 0;
  transform: scale(1) translate(50%, -50%);
  transform-origin: 100% 0%;
`;
const anchorOriginTopLeft = css`
  top: 0;
  left: 0;
  transform: scale(1) translate(-50%, -50%);
  transform-origin: 0% 0%;
`;
const anchorOriginBottomRight = css`
  right: 0;
  bottom: 0;
  transform: scale(1) translate(50%, 50%);
  transform-origin: 100% 100%;
`;
const anchorOriginBottomLeft = css`
  left: 0;
  bottom: 0;
  transform: scale(1) translate(-50%, 50%);
  transform-origin: 0% 100%;
`;

export {
  anchorOriginBottomLeft,
  anchorOriginBottomRight,
  anchorOriginTopRight,
  anchorOriginTopLeft,
};
